<!-- ===== AI ChatBot (AskChatBot) =====
     Floating launcher + conversation box. Visibility (session, view) is gated by the host
     (<app-chat-bot> in app.component.html); this template switches between the collapsed
     launcher and the open box. PAP: config / recon, opened from the floating launcher.
     PDP: the uClock scheduling assistant only, opened from the schedule builder toolbar
     (the corner launcher there belongs to "Ask us a question") and closed from its header. -->
<ng-container *ngIf="available">

<!-- Collapsed launcher -->
<div *ngIf="!showChatBot && !isPdp"
     style="
      position: fixed;
      bottom: 30px;
      right: 30px;
      width: 40px;
      height: 40px;
      background-color: white;
      border: 4px solid rgb(29, 62, 125);
      cursor: pointer;
      border-top-left-radius: 30px;
      border-top-right-radius: 30px;
      border-bottom-left-radius: 30px;
      display: flex;
      justify-content: center;
      z-index: 5000;
      align-items: center;
    "
     (click)="openChatBot()">
  <img src="../../../assets/images/chat_icon.png" width="16" height="15" />
</div>

<!-- Collapse handle (shown while the box is open) -->
<div *ngIf="showChatBot && !isPdp"
     style="
      position: fixed;
      bottom: 30px;
      right: 30px;
      width: 40px;
      height: 40px;
      background-color: white;
      border: 4px solid rgb(29, 62, 125);
      cursor: pointer;
      border-top-left-radius: 30px;
      border-top-right-radius: 30px;
      border-bottom-left-radius: 30px;
      display: flex;
      justify-content: center;
      z-index: 5000;
    "
     (click)="closeChatBot()">
  <i class="fa fa-chevron-down"
     aria-hidden="true"
     style="
        color: #1d3e7d;
        font-size: 16px;
        padding-top: 8px;
        font-weight: bold;
      "></i>
</div>

<!-- Responsive ChatBot box: flex column that scales with the viewport (.chat-bot-box
     in _chatGptSection.scss). History fills the available space and the prompt bar
     sticks to the box bottom — no viewport-fixed hacks, so it grows wider/taller on
     bigger screens and shrinks on small ones. -->
<div *ngIf="showChatBot">
  <div class="chat-bot-box">
    <div class="chat-bot-header">
      <div class="chat-bot-header-title">{{ headerTitle }}</div>

      <div class="chat-bot-header-actions">
        <!-- Topic = which assistant answers in this tab. Shown only when the user has more
             than one to choose from, and only until the conversation starts: each topic is a
             different agent with its own tools, so a running chat keeps the topic it began
             with (the server refuses otherwise) and switching subjects means a new chat. -->
        <ng-container *ngIf="availableTopics.length > 1">
          <select *ngIf="!topicLocked"
                  class="chat-bot-topic"
                  [value]="activeSession?.topic"
                  (change)="setTopic($any($event.target).value)"
                  title="{{ 'chatBot.chooseTopic' | gstranslate }}">
            <option *ngFor="let topic of availableTopics" [value]="topic.value">
              {{ topic.label }}
            </option>
          </select>

          <span *ngIf="topicLocked"
                class="chat-bot-topic-badge"
                title="{{ 'chatBot.topicFixed' | gstranslate }}">
            {{ topicLabel(activeSession?.topic) }}
          </span>
        </ng-container>

        <button type="button"
                class="chat-bot-new"
                (click)="newChat()"
                [disabled]="chatSessions.length >= maxTabs"
                title="{{ 'chatBot.startNew' | gstranslate }}">
          <i class="fa fa-plus" aria-hidden="true"></i> {{ 'chatBot.newChat' | gstranslate }}
        </button>

        <button *ngIf="isPdp"
                type="button"
                class="chat-bot-new"
                (click)="closeChatBot()"
                title="{{ 'chatBot.close' | gstranslate }}">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <!-- Chat tabs (max 3). Each tab is an independent conversation; the active one is
         shown below. New chat opens a fresh tab and leaves the current one in place. -->
    <div class="chat-bot-tabs">
      <button type="button"
              *ngFor="let session of chatSessions; let i = index"
              class="chat-bot-tab"
              [class.chat-bot-tab-active]="i === activeSessionIndex"
              (click)="selectSession(i)"
              [title]="tabTooltip(session)">
        <span class="chat-bot-tab-label">{{ tabTitle(session) }}</span>
        <span *ngIf="chatSessions.length > 1"
              class="chat-bot-tab-close"
              title="{{ 'chatBot.closeChat' | gstranslate }}"
              (click)="closeSession(i); $event.stopPropagation()">×</span>
      </button>
    </div>

    <div class="chat-bot-history" #chatBotHistory>
      <div *ngIf="activeSession?.showSpinner" class="chat-spiner-container">
        <div class="chat-spiner"
             style="background-color: white; border-radius: 50%">
          <img src="../../../assets/images/gs.logo.png"
               style="padding: 15px"
               width="100"
               height="100" />
        </div>
      </div>

      <div class="chat-bot-row chat-bot-row-assistant">
        <div class="chat-bot-bubble chat-bot-bubble-assistant">
          Hello, {{ Session.userName }}! {{ greeting }}
        </div>
        <div class="chat-bot-tag">{{ assistantTag }}</div>
      </div>

      <div *ngFor="let message of activeSession?.messages; let last = last">
        <!-- Assistant turn -->
        <div *ngIf="message.Role == 'assistant'">
          <div class="chat-bot-row chat-bot-row-assistant">
            <div class="chat-bot-bubble chat-bot-bubble-assistant">
              <ng-container *ngTemplateOutlet="content; context: { $implicit: message }"></ng-container>
            </div>
            <div class="chat-bot-tag">{{ assistantTag }}</div>
          </div>

          <!-- Scheduling assistant: proposed changes. Nothing has happened until Confirm;
               the server then runs exactly what the card says, once. -->
          <div *ngIf="message.Actions?.length" class="chat-bot-action-list">
            <button *ngIf="pendingCards(message).length > 1"
                    type="button"
                    class="chat-bot-action-confirm chat-bot-action-confirm-all"
                    (click)="confirmAllActions(activeSession, message)">
              {{ 'chatBot.confirmAll' | gstranslate: pendingCards(message).length }}
            </button>
            <div *ngFor="let card of message.Actions"
                 class="chat-bot-action-card"
                 [class.chat-bot-action-done]="card.status === 'executed'"
                 [class.chat-bot-action-failed]="card.status === 'failed'"
                 [class.chat-bot-action-closed]="card.status === 'cancelled' || card.status === 'expired'">
              <div class="chat-bot-action-title">{{ card.title }}</div>
              <div *ngFor="let line of card.details" class="chat-bot-action-detail">{{ line }}</div>
              <div *ngFor="let warning of card.warnings" class="chat-bot-action-warning">⚠ {{ warning }}</div>

              <div *ngIf="card.status === 'pending'" class="chat-bot-action-buttons">
                <button type="button"
                        class="chat-bot-action-confirm"
                        [disabled]="card.busy"
                        (click)="confirmAction(activeSession, card)">{{ 'chatBot.confirm' | gstranslate }}</button>
                <button type="button"
                        class="chat-bot-action-cancel"
                        [disabled]="card.busy"
                        (click)="cancelAction(activeSession, card)">{{ 'chatBot.cancel' | gstranslate }}</button>
              </div>
              <div *ngIf="card.status !== 'pending' || card.resultMessage" class="chat-bot-action-status">
                {{ cardStatusLabel(card) }}
              </div>
            </div>
          </div>

          <!-- PDF documents referenced by this answer (e.g. generated policies) -->
          <div *ngIf="message.Pdfs?.length" class="chat-bot-pdf-list">
            <button *ngFor="let pdf of message.Pdfs"
                    type="button"
                    class="chat-bot-pdf-card"
                    (click)="openPdf(pdf)"
                    [title]="pdf.uri">
              <span class="chat-bot-pdf-icon">📄</span>
              <span class="chat-bot-pdf-name">{{ pdf.name }}</span>
            </button>
          </div>

          <!-- Suggested next questions (only under the latest answer) -->
          <div *ngIf="last && message.Followups?.length" class="chat-bot-suggestions">
            <button *ngFor="let followup of message.Followups"
                    type="button"
                    class="chat-bot-suggestion"
                    (click)="sendChatBot(followup)">{{ followup }}</button>
          </div>
        </div>

        <!-- User turn -->
        <div *ngIf="message.Role == 'user'">
          <div class="chat-bot-row chat-bot-row-user">
            <div class="chat-bot-tag">{{ 'chatBot.you' | gstranslate }}</div>
            <div class="chat-bot-bubble chat-bot-bubble-user">
              <ng-container *ngTemplateOutlet="content; context: { $implicit: message }"></ng-container>
            </div>
          </div>

          <div *ngIf="message.Pdfs?.length" class="chat-bot-pdf-list chat-bot-pdf-list-user">
            <button *ngFor="let pdf of message.Pdfs"
                    type="button"
                    class="chat-bot-pdf-card"
                    (click)="openPdf(pdf)"
                    [title]="pdf.uri">
              <span class="chat-bot-pdf-icon">📄</span>
              <span class="chat-bot-pdf-name">{{ pdf.name }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="chat-bot-prompt">
      <input class="chat-bot-prompt-input"
             #chatBotPrompt
             type="text"
             id="chatBotPrompt"
             name="chatBotPrompt"
             [disabled]="activeSession?.showSpinner"
             (keyup.enter)="sendChatBot()"
             placeholder="{{ 'chatBot.typeMessage' | gstranslate }}" />
      <img src="../../../assets/images/send_chat.png"
           class="chat-bot-send"
           width="35"
           height="35"
           (click)="sendChatBot()" />
    </div>
  </div>
</div>

</ng-container>

<!-- Renders a message body as text + clickable (non-PDF) links. PDF references are
     pulled out into their own cards by the component, so they never appear here. -->
<ng-template #content let-message>
  <ng-container *ngFor="let part of message.Parts">
    <a *ngIf="part.href; else plain"
       [href]="part.href"
       target="_blank"
       rel="noopener noreferrer"
       class="chat-bot-link">{{ part.text }}</a>
    <ng-template #plain>{{ part.text }}</ng-template>
  </ng-container>
</ng-template>
